import { mapAttachmentApiModel } from '@webapp/core/data-access/mappers/mapAttachment'
import { mapCurrency } from '@webapp/core/data-access/mappers/mapCurrency'
import { mapCustomFieldValue } from '@webapp/core/data-access/mappers/mapCustomField'
import { mapOrderItemAccount } from './mapOrderItemAccountApiModel'
import { mapOrderItemBlanketDetails } from './mapOrderItemBlanketDetails'
import { mapOrderItemPunchOutSupplier } from './mapOrderItemPunchOutSupplier'
import { mapOrderItemRecurringDetails } from './mapOrderItemRecurringDetails'
import { mapPreferredVendorApiModel } from './mapPreferredVendorApiModel'
import { type OrderDraftItemConstructorData } from '../../entities/OrderDraftItem'
import { type OrderDraftItemApiModel } from '../api-models/OrderDraftItemApiModel'

export const mapOrderDraftItemApiModel = (
  orderItem: OrderDraftItemApiModel
): OrderDraftItemConstructorData => ({
  id: orderItem.id,
  name: orderItem.name,
  type: orderItem.type,
  account: orderItem.account ? mapOrderItemAccount(orderItem.account) : null,
  customFields: orderItem.custom_fields?.map(mapCustomFieldValue) ?? [],
  attachments: orderItem.item_attachments?.map(mapAttachmentApiModel) ?? [],
  sku: orderItem.sku,
  comment: orderItem.line_comment,
  currency: orderItem.currency ? mapCurrency(orderItem.currency) : null,
  preferredVendor: orderItem.pref_vendor
    ? mapPreferredVendorApiModel(orderItem.pref_vendor)
    : null,
  price: orderItem.price,
  quantity: orderItem.quantity ? Number.parseFloat(orderItem.quantity) : null,
  unit: orderItem.unit,
  shippingAmount: orderItem.shipping_amount,
  taxAmount: orderItem.tax_amount,
  totalCost: orderItem.total_cost,
  vendorName: orderItem.vendor,
  receivingMethod: orderItem.receive_method,
  blanketItemDetails: mapOrderItemBlanketDetails(orderItem.blanket),
  recurringItemDetails: mapOrderItemRecurringDetails(orderItem.recurrence),
  catalogItemRef: orderItem.catalog_item?.id || null,
  punchoutSupplier: mapOrderItemPunchOutSupplier(orderItem),
  order: {
    id: orderItem.order_num_id,
  },
  lineNumber: Number.parseInt(orderItem.num, 10),
})
